export default __webpack_public_path__ + "static/media/orissa.3eba3046.jpg";